export const PERMISSIONS_HEALTH = {
  "CAN_VIEW_HEALTH_SERVICEPORT_OVERVIEW": 101101,
  "CAN_VIEW_HEALTH_SERVICEPORT_COUNTUPTIMER": 101102,
  "CAN_VIEW_HEALTH_SERVICEPORT_LISTOFSERVICES": 101103,
  "CAN_VIEW_HEALTH_SERVICEPORT_CALLCHART": 101104,
  "CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW": 1012101,
  "CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_COUNT": 1012102,
  "CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_PERCENT": 1012103,
  "CAN_VIEW_HEALTH_VACCINATION_GENERAL_OVERVIEW_VACCINE_STATUS_CHART": 1012104,
  "CAN_VIEW_HEALTH_VACCINATION_PROVINCE_MAP": 1012201,
  "CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW": 1012202,
  "CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_COUNT": 1012203,
  "CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_PERCENT": 1012204,
  "CAN_VIEW_HEALTH_VACCINATION_PROVINCE_OVERVIEW_VACCINE_STATUS_CHART": 1012205,

  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW": 1013101,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_SAMAS": 1013102,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_CATEGORY": 1013103,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_PUBLIC_PATIENTS": 1013104,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_VACCINE_PROCESS": 1013105,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CARD": 1013106,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CHART": 1013107,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_OF_VACCINATION_IN_PUBLIC_TRANSPORT": 1013108,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_OF_THE_PUBLIC_TRANSPORT_VACCINATION_STATUS": 1013109,
  "CAN_VIEW_HEALTH_TRANSPORT_GENERAL_OVERVIEW_TABLE_OF_TESTS_IN_TRANSPORT": 1013110,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_MAP": 1013201,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW": 1013202,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_SAMAS": 1013203,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_CATEGORY": 1013204,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_PUBLIC_PATIENTS": 1013205,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_VACCINE_PROCESS": 1013206,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CARD": 1013207,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_THE_LATEST_PUBLIC_TRANSPORT_VACCINATION_STATUS_CHART": 1013208,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_OF_VACCINATION_IN_PUBLIC_TRANSPORT": 1013209,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_OF_THE_PUBLIC_TRANSPORT_VACCINATION_STATUS": 1013210,
  "CAN_VIEW_HEALTH_TRANSPORT_PROVINCE_OVERVIEW_TABLE_OF_TESTS_IN_TRANSPORT": 1013211,
  "CAN_VIEW_HEALTH_TRANSPORT_AUDIT_MAP": 1013301,
  "CAN_VIEW_HEALTH_TRANSPORT_AUDIT_OVERVIEW_DRIVER_STATUS": 1013302,
  "CAN_VIEW_HEALTH_TRANSPORT_AUDIT_OVERVIEW_DRIVER_STATUS_DOWNLOAD": 1013303,

  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW": 10141101,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_CATEGORY": 10141102,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_POSITIVE_PCR": 10141103,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_OF_GUILD_VACCINATION_PROCESS": 10141104,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION": 10141105,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE": 10141106,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_PERCENTAGE": 10141107,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILD_REGISTER_NUMBER": 10141108,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_VACCINATION": 10141109,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_GUILDS_PER_PROVINCE": 10141110,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_TEST_STATUS": 10141111,
  "CAN_VIEW_HEALTH_GUILD_OWNER_GENERAL_OVERVIEW_REGISTER_GUILD": 10141112,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_MAP": 10141201,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW": 10141202,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_CATEGORY": 10141203,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_POSITIVE_PCR": 10141204,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OF_GUILD_VACCINATION_PROCESS": 10141205,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION": 10141206,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_OVERVIEW_VACCINATION": 10141207,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_TEST_STATUS": 10141208,
  "CAN_VIEW_HEALTH_GUILD_OWNER_PROVINCE_OVERVIEW_REGISTER_GUILD": 10141209,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW": 10141301,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_CATEGORY": 10141302,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_PER_PROVINCE": 10141303,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_VACCINATION": 10141304,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_GENERAL_OVERVIEW_TEST_STATUS": 10141305,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_MAP": 10142101,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW": 10142102,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_CATEGORY": 10142103,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_PER_PROVINCE": 10142104,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_VACCINATION": 10142105,
  "CAN_VIEW_HEALTH_GUILD_EMPLOYEE_PROVINCE_OVERVIEW_TEST_STATUS": 10142106,
  "CAN_VIEW_HEALTH_GUILD_AUDIT_MAP": 1014301,
  "CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_NOT_SCANED": 1014302,
  "CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_NOT_SCANED_DOWNLOAD": 1014303,
  "CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_POSITIVE": 1014304,
  "CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_POSITIVE_DOWNLOAD": 1014305,
  "CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_UNVACCINATED": 1014306,
  "CAN_VIEW_HEALTH_GUILD_AUDIT_OVERVIEW_UNVACCINATED_DOWNLOAD": 1014307,

  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_STATUS_CARD": 1015101,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_AIRLINES_PASSENGERS_STATUS_CARD": 1015102,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_BUS_PASSENGERS_STATUS_CARD": 1015103,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_TRAIN_PASSENGERS_STATUS_CARD": 1015104,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_SHIP_PASSENGERS_STATUS_CARD": 1015105,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_VACCINATE": 1015106,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PASSENGER_STATUS_VACCINATE_CHART": 1015107,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_PATIENTS": 1015108,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_OF_LATEST_PASSENGERS_VACCINATION_STATUS": 1015109,
  "CAN_VIEW_HEALTH_PASSENGER_GENERAL_OVERVIEW_OF_TRIPS_MADE_BY_PASSENGERS_BY_VEHICLE": 1015110,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_MAP": 1015201,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGER_STATUS_CARD": 1015202,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_AIRLINES_PASSENGERS_STATUS_CARD": 1015203,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_BUS_PASSENGERS_STATUS_CARD": 1015204,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_TRAIN_PASSENGERS_STATUS_CARD": 1015205,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_SHIP_PASSENGERS_STATUS_CARD": 1015206,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGER_VACCINATE": 1015207,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_PASSENGERS_VACCINE_PER_DOSES_PROVINCE": 1015208,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_OF_AFFECTED_AFTER_TRAVELING_IN_COUNTRY_PROVINCE": 1015209,
  "CAN_VIEW_HEALTH_PASSENGER_PROVINCE_OVERVIEW_OF_TRIPS_MADE_BY_PASSENGERS_BY_VEHICLE_PROVINCE": 1015210,

  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_EDUCATIONAL_EMPLOYE": 1016101,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_DEPARTMENT_EMPLOYE": 1016102,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_STEUDENT": 1016103,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_CATEGORIES": 1016104,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_SCHOOLS_POSITIVE_PCR": 1016105,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_OF_VACCINATION_PROCESS": 1016106,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION": 1016107,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE": 1016108,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_SCHOOLS_VACCINATION_PERCENTAGE_PER_GRADE": 1016109,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_VACCINATION": 1016110,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_TO_VACCINATION_STATUS": 1016111,
  "CAN_VIEW_HEALTH_SCHOOL_GENERAL_OVERVIEW_TEST_STATUS": 1016112,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_MAP": 1016201,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_EDUCATIONAL_EMPLOYE": 1016202,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_DEPARTMENT_EMPLOYE": 1016203,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_STEUDENT": 1016204,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_CATEGORIES": 1016205,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_SCHOOLS_POSITIVE_PCR": 1016206,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_OF_VACCINATION_PROCESS": 1016207,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_THE_LATEST_OVERWIEW_OF_VACCINATION": 1016208,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_GUILD_POSITIVE_PCR_PERCENTAGE": 1016209,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_SCHOOLS_VACCINATION_PERCENTAGE_PER_GRADE": 1016210,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_VACCINATION": 1016211,
  "CAN_VIEW_HEALTH_SCHOOL_PROVINCE_OVERVIEW_TEST_STATUS": 1016212,

  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW": 1017101,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_CATEGORY": 1017102,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_PATIENTS": 1017103,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_GOVERNMENT_EMPLOYEES_VACCINATION_PROCESS": 1017104,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CHART": 1017105,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CARD": 1017106,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_PERCENTAGE_OF_GOVERNMENT_EMPLOYEES_IN_EACH_PROVINCE": 1017107,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_OF_VACCINATION": 1017108,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_VACCINE_PER_PROVINCE": 1017109,
  "CAN_VIEW_HEALTH_RECRUITMENT_GENERAL_OVERVIEW_TEST_STATUS": 1017110,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_MAP": 1017201,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW": 1017202,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_CATEGORY": 1017203,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_PATIENTS": 1017204,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_GOVERNMENT_EMPLOYEES_VACCINATION_PROCESS": 1017205,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CHART": 1017206,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_THE_LATEST_GOVERNMENT_EMPLOYEES_VACCINATION_STATUS_CARD": 1017207,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_OF_VACCINATION": 1017208,
  "CAN_VIEW_HEALTH_RECRUITMENT_PROVINCE_OVERVIEW_TEST_STATUS": 1017209,

  "CAN_VIEW_HEALTH_REPORTS_TRANSPORT_REPORT": 101801,
  "CAN_VIEW_HEALTH_REPORTS_TRANSPORT_REPORT_DOWNLOAD": 101802,
  "CAN_VIEW_HEALTH_REPORTS_GUILD_REPORT": 101803,
  "CAN_VIEW_HEALTH_REPORTS_GUILD_REPORT_DOWNLOAD": 101804,
};

export const PERMISSIONS_GUILD = {
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW": 1021101,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_BAKERY_INSPECTION_NEED": 1021102,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_AUDIT": 1021103,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_INVALID_GUILD_CODE": 1021104,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_DEAD_OWNER": 1021105,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_PERMISSION": 1021106,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_LICENCE": 1021107,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_ACTIVE_TIME": 1021108,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SELL_COST_AVERAGE": 1021109,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SOLD_COUNT": 1021110,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SELL_RATE": 1021111,
  "CAN_VIEW_GUILD_BAKERY_GENERAL_OVERVIEW_SUPPLY_FLOUR": 1021112,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_MAP": 1021201,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW": 1021202,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_BAKERY_INSPECTION_NEED": 1021203,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_AUDIT": 1021204,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_INVALID_GUILD_CODE": 1021205,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_DEAD_OWNER": 1021206,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_PERMISSION": 1021207,
  "CAN_VIEW_GUILD_BAKERY_PROVINCE_OVERVIEW_LICENCE": 1021208,
  "CAN_VIEW_GUILD_BAKERY_AUDIT_OVERVIEW": 1021301,
  "CAN_VIEW_GUILD_INSPECTOR_USER_MANAGEMENT": 1021311,
};

export const PERMISSIONS_ZAERIN = {};

export const PERMISSIONS = {
  ...PERMISSIONS_HEALTH,
  ...PERMISSIONS_GUILD,
  ...PERMISSIONS_ZAERIN,
};
